<template>
  <div>
    <form-wrapper :validator="$v.model">
      <b-row>
        <b-col sm="6">
          <b-form-group
            id="input-group-8"
            :label="$t('quoteOfferForm.surnameLabel')"
            label-for="input-8"
          >
            <template #label>
              <strong>{{ $t('quoteOfferForm.surnameLabel') }} </strong>
            </template>
            <b-form-input
              id="input-8"
              v-model="model.lastName"
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              :state="$v.model.lastName.$error ? false : null"
              @change="$v.model.lastName.$touch()"
              :placeholder="$t('quoteOfferForm.surnamePlaceHolder')"
              :readonly="loading"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            id="input-group-9"
            :label="$t('quoteOfferForm.firstNameLabel')"
            label-for="input-9"
          >
            <template #label>
              <strong>{{ $t('quoteOfferForm.firstNameLabel') }} </strong>
            </template>
            <b-form-input
              id="input-9"
              v-model="model.firstName"
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              :state="$v.model.firstName.$error ? false : null"
              @change="$v.model.firstName.$touch()"
              :placeholder="$t('quoteOfferForm.firstNamePlaceHolder')"
              :readonly="loading"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            id="input-group-4"
            :label="$t('quoteOfferForm.roomNumberLabel')"
            label-for="input-4"
          >
            <template #label>
              <strong>{{ $t('quoteOfferForm.roomNumberLabel') }} </strong>
            </template>
            <b-form-input
              id="input-4"
              v-model="model.roomNumber"
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              :state="$v.model.roomNumber.$error ? false : null"
              @change="$v.model.roomNumber.$touch()"
              :placeholder="$t('quoteOfferForm.roomNumberPlaceHolder')"
              :readonly="loading"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col align="right">
          <b-button
            type="submit"
            variant="primary"
            class="mx-2 mb-3"
            :disabled="loading"
            @click="onSubmit"
          >
            <b-spinner v-if="loading" small></b-spinner>{{ $t('find') }}
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="reservationNotFound" class="mt-2">
        <b-col>
          <b-alert show variant="warning"
            >{{ $t('quoteOfferForm.reservationNotFound') }}
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="reservations && reservations.length > 0">
        <b-col>
          <b-alert show variant="warning">
            {{ $t('quoteOfferForm.foundReservations') }}
            <ul>
              <li v-for="(reservation, i) in reservations" :key="i">
                <span
                  v-html="
                    $t('quoteOfferForm.reservation', {
                      progress: reservation.progress,
                      start: reservation.checkIn,
                      end: reservation.checkOut,
                    })
                  "
                />

                <a
                  href="#"
                  v-on:click.prevent="connectReservation(reservation.progress)"
                >
                  {{ $t('proceed') }}</a
                >
              </li>
            </ul>
          </b-alert>
        </b-col>
      </b-row>
      <div style="margin-bottom: 20px">
        <form-summary :attributes="attributes" />
      </div>
    </form-wrapper>
    <b-modal
      id="find-reservation-number-modal"
      v-model="showModal"
      hide-footer
      hide-title
    >
      <template>
        <span
          v-html="$t('quoteOfferForm.reservationHtmlLabel')"
        ></span> </template
    ></b-modal>
  </div>
</template>

<script>
import { LocalStorage } from '@/common/LocalStorage';
import { ContactService, OfferRequestService } from '@/common/ApiService';
import { format } from 'date-fns';
import {
  required,
  integer,
  minLength,
  maxLength,
  email,
  between,
} from 'vuelidate/lib/validators';

export default {
  name: 'ReservationInfoFromRoom',
  props: {
    value: {
      type: Date,
      required: true,
    },
    propertyCODE: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      date: this.value,
      reservationNotFound: false,
      showModal: false,
      model: {
        progress: null,
        reservationID: null,
        email: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        startDate: null,
        endDate: null,
        roomNumber: null,
      },
      reservations: [],
      // form: {
      //   progress: null,
      //   email: '',
      //   checkIn: null,
      // },
      attributes: {
        firstName: this.$t('form.firstName'),
        lastName: this.$t('form.lastName'),
        roomNumber: this.$t('form.roomNumber'),
      },
    };
  },
  validations: {
    model: {
      lastName: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      firstName: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      roomNumber: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
    },
  },
  async created() {
    let contactID = undefined;
    if ((this.$route.query || {}).contactID) {
      contactID = parseInt(this.$route.query.contactID);
    }
    if (
      (this.$route.query || {}).contactID &&
      (this.$route.query || {}).reservationID
    ) {
      let reservationID = parseInt(this.$route.query.reservationID);
      let params = { reservationID, contactID };
      let response = await OfferRequestService.getReservationInfoAsync(params);
      if (response.data) {
        const progress = parseInt(response.data.progress);
        const model = response.data;
        let reservations = [
          {
            reservationID: parseInt(this.$route.query.reservationID),
            checkIn: model.checkIn,
            checkOut: model.checkOut,
            progress: progress,
            firstName: model.firstName,
            surname: model.surname,
            email: model.email,
            phoneNumber: model.phoneNumber,
          },
        ];
        if (Boolean(reservations[0])) {
          reservations[0].contactID = contactID;
        }
        this.populateReservationsFound(reservations);
        this.populateInfoContact(reservations[0]);
        this.connectReservation(progress);
      }
      if (contactID > 0) {
        response = await ContactService.getContactAsync(contactID);
        if (response.data) {
          let contact = response.data;
          this.model.contactID = contact.contactID;
          this.model.lastName = contact.lastName;
          this.model.firstName = contact.firstName;
        }
      }
    }
  },
  methods: {
    onClick() {
      this.showModal = true;
    },
    validate() {
      this.$v.$touch();
    },
    async onSubmit() {
      this.validate();
      if (!this.$v.$invalid) {
        try {
          this.reservationNotFound = false;
          this.loading = true;
          var response = await OfferRequestService.getReservationByRoomNumber({
            lastName: this.model.lastName,
            firstName: this.model.firstName,
            roomNumber: this.model.roomNumber,
            startDate: this.value.toISOString(),
            propertyCODE: this.propertyCODE,
          });

          if (response.data && response.data.length > 0) {
            this.populateReservationsFound(response.data);
            this.populateInfoContact(response.data[0]);
            // this.setSessionStorage(response.data, 'reservation');
          } else {
            this.reservationNotFound = true;
          }
        } catch (e) {
          console.log(e);
        }
        this.loading = false;
        // this.$emit('reservationFound', this.model);
      }
    },
    populateReservationsFound(reservations) {
      this.reservations = [];
      reservations.forEach((reservation) => {
        this.reservations.push({
          reservationID: reservation.reservationID,
          progress: reservation.progress,
          checkIn: format(reservation.checkIn, 'DD-MM-YYYY'),
          checkOut: format(reservation.checkOut, 'DD-MM-YYYY'),
        });
      });
    },
    populateInfoContact(model) {
      Object.assign(this.model, model);
    },
    findReservationSkip() {
      this.$emit('findReservationSkipped');
    },

    setSessionStorage(model, key) {
      LocalStorage.set(model, key);
    },
    connectReservation(progress) {
      let selected = this.reservations.find((x) => x.progress == progress);
      this.model.reservationID = selected.reservationID;
      this.$emit('reservationFound', this.model);
    },
  },
};
</script>

<style></style>
